module.exports = __webpack_public_path__ + "svg/garment-bag.2989bf22b874884ef09673f68e8cb82e.svg";